import * as S from './styles';

const ELEMENTS_SIZE = 6;

export function Loader() {
  function renderSkeletonList() {
    const elementsToRender = new Array(ELEMENTS_SIZE).fill(null);

    return elementsToRender.map((_, index) => (
      <S.SkeletonItem key={index}>
        <S.Section>
          <S.Container>
            <S.Line $variant="code" />
            <S.Line $variant="name" />
          </S.Container>

          <S.Container $alignEnd>
            <S.Line $variant="sales-mode-icon" />
            <S.Line $variant="sales-mode" />
          </S.Container>
        </S.Section>

        <S.Division />

        <S.Section $alignEnd>
          <S.Container>
            <S.Line $variant="date" />
            <S.Line $variant="status" />
          </S.Container>
        </S.Section>
      </S.SkeletonItem>
    ));
  }

  return <S.Wrapper>{renderSkeletonList()}</S.Wrapper>;
}
